<template>
    <div id="page-branch-list">
        <div class="vx-card p-6">
            <div class="flex-grow">
                <div class="vx-col md:w-1/4 sm:w-auto mr-4">
                    <label class="vs-input--label"> {{$t('workShift.branch')}}</label>
                    <v-select class="" v-model="selectedOrganizationBranch" :clearable="false"
                              :options="organizationBranchOptions">
                        <span slot="no-options"> {{$t('menuOrganization.emptyList')}}</span>
                    </v-select>
                </div>
            </div>
            <div class="flex flex-wrap items-center mt-5">
                <div class="flex-grow">
                    <vs-button
                        v-if="isPermissionAdd()"
                        @click="addWorkShift"
                        color="primary"
                        type="border"
                        icon-pack="feather"
                        icon="icon-settings">
                        {{$t('workShift.addWork')}}
                    </vs-button>

                </div>

                <!-- ITEMS PER PAGE -->
                <Pagination
                    :itemList="workShiftInfo.workShiftSetting"
                    :currentPage="currentPage"
                    :paginationPageSize="paginationPageSize"
                    :gridApi="gridApi"
                />

                <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                          v-model="searchQuery"
                          @input="updateSearchQuery" :placeholder="$t('button.search')"/>
            </div>
            <!-- AgGrid Table -->
            <ag-grid-vue style="height: 55vh"
                         ref="agGridTable"
                         :components="components"
                         :gridOptions="gridOptions"
                         class="ag-theme-material w-100 my-4 ag-grid-table"
                         :columnDefs="columnDefs"
                         :defaultColDef="defaultColDef"
                         :rowData="workShiftInfo.workShiftSetting"
                         :animateRows="true"
                         :pagination="true"
                         :localeText=" {noRowsToShow: this.$t('menuCamera.noRowsToShow')}"
                         :paginationPageSize="paginationPageSize"
                         :onGridReady="onGridReady"
                         :suppressPaginationPanel="true">
            </ag-grid-vue>

            <vs-pagination
                :total="totalPages"
                :max="maxPageNumbers"
                v-model="currentPage"/>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import {AgGridVue} from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import Pagination from "../../../ui-elements/Pagination.vue"
import CellRendererActions from "./cell-renderer/OrganizationBranchCellRendererActions.vue"
import utils from "../../../../components/utils"
import { isRouter } from '../../../../store/permission'
import { constRouter } from '../../../../store/constant'

export default {
    components: {
        AgGridVue,
        vSelect,
        // Cell Renderer
        CellRendererActions,
        Pagination
    },
    data() {
        return {
            searchQuery: "",
            maxPageNumbers: 7,
            // AgGrid
            gridApi: null,
            gridOptions: {},
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: 'ID',
                    field: 'id',
                    width: 100
                },
                {
                    headerName: this.$t('workShift.group'),
                    field: 'groupName',
                    width: 200
                },
                {
                    headerName: this.$t('workShift.shiftName'),
                    field: 'name',
                    width: 150
                },
                {
                    headerName: this.$t('workShift.begin'),
                    field: 'startHour',
                    width: 150,
                },
                {
                    headerName: this.$t('workShift.finish'),
                    field: 'endHour',
                    width: 150,
                },
                {
                    headerName: this.$t('workShift.flexibleTime'),
                    field: 'bufferTime',
                    width: 150,
                },
                {
                    headerName: this.$t('workShift.actions'),
                    field: 'actions',
                    width: 120,
                    cellRendererFramework: 'CellRendererActions',
                },
            ],
            // Cell Renderer Components
            components: {
                CellRendererActions,
            },
            workShiftInfo: {
                name: '',
                workShiftSetting: []
            },
            timeSpans: [],
            organizationBranchOptions: [],
            selectedOrganizationBranchValue: null,
            workDayOfWeekOptions: [
                {value: 2, label: 'Thứ 2'},
                {value: 3, label: 'Thứ 3'},
                {value: 4, label: 'Thứ 4'},
                {value: 5, label: 'Thứ 5'},
                {value: 6, label: 'Thứ 6'},
                {value: 7, label: 'Thứ 7'},
                {value: 1, label: 'Chủ nhật'}
            ]
        }
    },
    created() {
        let timeDuration = 30, timeSpans = [];
        for (let i = 0; i < 24 * 60; i = i + timeDuration) {
            timeSpans.push({value: i, label: utils.minuteToHour(i)});
        }
        this.timeSpans = timeSpans;
        this.initScreen()
    },
    watch: {
        '$store.state.windowWidth'(val) {
            if (val <= 1024) {
                this.maxPageNumbers = 5;
            } else {
                this.maxPageNumbers = 7;
            }

            if (val > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        '$store.state.reduceButton'() {
            setTimeout(() => {
                this.gridApi.sizeColumnsToFit();
            }, 650);
        },
        '$store.state.isUpdateOrganizationWorkShift'(val) {
            if (val) {
                this.initScreen();
                this.$store.commit('UPDATE_ORGANIZATION_WORK_SHIFT', false);
            }
        }
    },
    computed: {
        paginationPageSize() {
            if (this.gridApi) return this.gridApi.paginationGetPageSize();
            else return 20
        },
        totalPages() {
            if (this.gridApi) return this.gridApi.paginationGetTotalPages();
            else return 0
        },
        currentPage: {
            get() {
                if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
                else return 1
            },
            set(val) {
                this.gridApi.paginationGoToPage(val - 1)
            }
        },
        selectedOrganizationBranch: {
            get() {
                return {
                    label: this.organizationBranchString(this.selectedOrganizationBranchValue),
                    value: this.selectedOrganizationBranchValue
                }
            },
            set(obj) {
                this.selectedOrganizationBranchValue = obj.value
                this.loadWorkShift()
            }
        }
    },
    methods: {
        isPermissionAdd() {
            return isRouter(this, constRouter.work_shift_branch_add)
        },
        updateSearchQuery(val) {
            this.gridApi.setQuickFilter(val)
        },
        organizationBranchString(id) {
            let organizationBranch = this.organizationBranchOptions.find(x => x.value === id);
            return (organizationBranch && organizationBranch.label) || this.$t('textCamera.undefined');
        },
        addWorkShift() {
            this.$router.push(`/user/add-work-shift?branch_id=${this.selectedOrganizationBranchValue}`).catch(() => {
            });
        },
        onGridReady() {
            if (this.$store.state.windowWidth <= 1024) {
                this.maxPageNumbers = 5;
            } else {
                this.maxPageNumbers = 7;
            }

            if (this.$store.state.windowWidth > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        initScreen() {
            let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]')
            if (branchList.length == 0) {
                return this.$vs.notify({
                    text: 'Hiện tại không tồn tại chi nhánh nào',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            this.organizationBranchOptions = branchList.map(item => {
                return {value: item.id, label: item.organizationBranchName}
            })
            let branchId = this.$route.query.branch_id;
            let index = 0;
            if (branchId) {
                index = this.organizationBranchOptions.findIndex(item => item.value == branchId)
            }
            this.selectedOrganizationBranch = this.organizationBranchOptions[index > -1 ? index : 0];
        },
        loadWorkShift() {
            if (!this.selectedOrganizationBranchValue) return;

            this.$vs.loading();
            this.$crm.post('/work-shift/organization/find-by-organization-branch/' + this.selectedOrganizationBranchValue).then((response) => {
                let workShiftInfo = response.data;
                workShiftInfo.workShiftSetting.map(item => {
                    item.organizationBranchId = this.selectedOrganizationBranchValue
                    item.startHour = this.timeSpans.find(timeSpan => timeSpan.value == item.startHour).label;
                    item.endHour = this.timeSpans.find(timeSpan => timeSpan.value == item.endHour).label;
                })
                workShiftInfo.workShiftSetting.sort((item1, item2) => {
                    if (item1.groupName < item2.groupName) return -1;
                    if (item1.groupName > item2.groupName) return 1;
                    return 0;
                });
                this.workShiftInfo = workShiftInfo;
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Có lỗi sảy ra!',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        }
    },
    mounted() {
        this.gridApi = this.gridOptions.api;
    },
}
</script>

<style scoped>

</style>
